<template>
    <div>
        <FinalSubmitCheckedComponent
                v-if="ckeckedFinalSubmitCheckedComponent()"/>
        <FinalSubmitRedeemComponent
                v-if="checkedFinalSubmitRedeemComponent()"/>

        <v-card  v-if="!ckeckedFinalSubmitCheckedComponent() && !checkedFinalSubmitRedeemComponent()">
            <v-list subheader two-line>
                <v-subheader class="justify-center red--text">
                    Δεν έχετε επιλέξει κάποιο μάθημα
                </v-subheader>
            </v-list>
        </v-card>
    </div>
</template>

<script>

    import FinalSubmitCheckedComponent from "./FinalSubmitCheckedComponent";
    import FinalSubmitRedeemComponent from "./FinalSubmitRedeemComponent";

    export default {
        name: "DeclarationStatementBooks",
        components: {
            FinalSubmitRedeemComponent,
            FinalSubmitCheckedComponent
        },
        data() {
            return {

            }
        },
        methods: {
            ckeckedFinalSubmitCheckedComponent() {
                return this.$store.getters.booksFromCheckedByDistPoint.length > 0 || this.$store.getters.booksFromCheckedByCourrier.length > 0;
            },
            checkedFinalSubmitRedeemComponent() {
                return this.$store.getters.booksFromRedeemByDistPoint.length > 0 || this.$store.getters.booksFromRedeemByCourrier.length > 0;
            }
        }
    }
</script>

<style scoped>

</style>